export function validateLibraryCapacity(value) {
  const keys = ['library_image_limit', 'library_image_count', 'remaining_image_slots']
  if (!value || keys.some(key => !Number.isSafeInteger(value[key]) || value[key] < 0) ||
      value.remaining_image_slots !== Math.max(0, value.library_image_limit - value.library_image_count)) {
    throw Object.assign(new Error('容量数据暂时不完整，请重新读取容量。'), { code: 'CAPACITY_RESPONSE_INVALID' })
  }
  return value
}

export function uploadCapacityIssue(count, status, capacity) {
  if (!count) return ''
  if (count > 14) return '每次最多准备14张图片，请减少本次选择。'
  if (status === 'loading') return '正在读取素材库容量，请稍候。'
  if (status !== 'ready') return '容量暂时读取失败，图片和说明已保留，请重新读取容量。'
  try { validateLibraryCapacity(capacity) } catch (error) { return error.message }
  const remaining = capacity.remaining_image_slots
  if (!remaining) return '素材库已满，请先撤回不再使用的图片。'
  return count > remaining ? `本次选择${count}张，素材库还可上传${remaining}张，请减少本次选择。` : ''
}

export function createCapacityLoader({ read, onState, isCurrent, delay = ms => new Promise(resolve => setTimeout(resolve, ms)) }) {
  let sequence = 0, pending = null, pendingKey = ''
  return {
    cancel() { ++sequence; pending = null; pendingKey = '' },
    load(scope) {
      const key = `${scope.tenant}/${scope.project}`
      if (pending && pendingKey === key) return pending
      const request = ++sequence
      const current = () => sequence === request && isCurrent(scope)
      onState('loading', null, '')
      const operation = (async () => {
        for (let attempt = 0; attempt < 2; attempt++) {
          try {
            const value = validateLibraryCapacity(await read(scope.tenant, scope.project))
            if (current()) onState('ready', value, '')
            return current() ? value : null
          } catch (error) {
            if (!current()) return null
            const retry = attempt === 0 && ![401, 403].includes(error?.status) && error?.code !== 'CAPACITY_RESPONSE_INVALID'
            if (retry) { await delay(600); if (!current()) return null; continue }
            onState('error', null, error?.message || '容量暂时读取失败，图片和说明已保留。')
            return null
          }
        }
      })().finally(() => { if (pending === operation) { pending = null; pendingKey = '' } })
      pending = operation; pendingKey = key
      return operation
    },
  }
}
